import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID
}

let app = null
let auth = null
let firebaseError = null

try {
  if (!firebaseConfig.apiKey) {
    throw new Error('Firebase API key is missing')
  }
  app = initializeApp(firebaseConfig)
  auth = getAuth(app)
} catch (error) {
  console.error('Firebase initialization failed:', error)
  firebaseError = error
}

export { auth, firebaseError }